import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import AdminAuthContainer from './AdminAuthContainer';
import LeftMenuNav from './LeftMenuNav';
import SettingsBody from './SettingsBody';
import Error403 from '../../pages/Error403';
import Loading from '../../pages/Loading';

const GridContainer = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
`;

const Settings = () => {
    const { isAdmin, isSuperAdmin, isLoading } = useContainer(AdminAuthContainer);
    const showSettings = isAdmin || isSuperAdmin;

    if (isLoading) {
        return <Loading />;
    }

    if (!showSettings) {
        return <Error403 pt="32px" />;
    }

    return (
        <GridContainer>
            <LeftMenuNav />
            <div style={{ padding: 18, flexGrow: 1 }}>
                <SettingsBody />
            </div>
        </GridContainer>
    );
};

export default Settings;
